import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import 'sal.js/dist/sal.css';
import sal from 'sal.js';
import { render } from 'storyblok-rich-text-react-renderer';

import ResImg from 'components/resImg';

const TeamMember = ({ blok }) => {
  const { name, title, copy_title, copy, studios } = blok;
  const renderedCopy = render(copy);
  useEffect(() => {
    sal({ threshold: 0.25 });
  }, []);

  return (
    <>
      <div className="h-mobile-fs xl:h-desktop-fs">
        <ResImg mobile={blok.mobile_image} desktop={blok.desktop_image} critical />
      </div>
      <div
        className="container py-14 lg:py-16 xl:py-20"
        {...{
          'data-sal': 'slide-up',
          'data-sal-duration': '1000',
          'data-sal-delay': '0',
          'data-sal-easing': 'ease',
        }}
      >
        <div className="grid gap-8 lg:grid-cols-2">
          <div className="space-y-8 lg:space-y-16 xl:space-y-20">
            <div className="text-lg leading-[1.2] lg:text-2xl lg:leading-[1.25] xl:text-3.5xl">
              <h1 className="font-semibold tracking-wide">{name}</h1>
              <span>{title}</span>
            </div>
            <div className="flex gap-20 lg:gap-16">
              <p className="text-sm font-semibold leading-none lg:text-base xl:text-[1.375rem]">
                Studio{studios.length > 1 ? 's' : ''}
              </p>
              <ul className="space-y-2 text-sm leading-none lg:text-lg xl:-mt-[0.15rem] xl:space-y-3 xl:text-2xl">
                {studios.map((studio) => (
                  <li key={studio._uid}>{studio.name}</li>
                ))}
              </ul>
            </div>
          </div>
          <div className="space-y-8 lg:space-y-16 xl:space-y-20">
            <p className="text-lg lg:text-2xl lg:!leading-[1.25] xl:text-3.5xl">{copy_title}</p>
            <div className="prose text-sm lg:text-lg lg:!leading-[1.10] xl:text-2xl">
              {renderedCopy}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeamMember;

TeamMember.propTypes = {
  blok: PropTypes.object.isRequired,
};
